import { FaPlay } from 'react-icons/fa';
import styles from './PlayAllCard.module.css';

/**
 * Card que dispara a reprodução de toda a playlist de música da pasta atual.
 */
export default function PlayAllCard({ onClick }) {
  return (
    <div className={styles.folder} onClick={onClick}>
      <FaPlay className={styles.icon} />
      <div className={styles.label}>Tocar Tudo...</div>
    </div>
  );
}